import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, Palette } from 'lucide-react';
import colors from '../theme/colors';
import { Button } from '../components/ui/button';
import logo from "../assets/logo.png";

const Home = () => {
  return (
    <div style={{ backgroundColor: colors.background }} className="min-h-screen">
      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-2 py-1">
        <div className="mb-16">
          <img
            src={logo}
            alt="HennabyAnjali Logo"
            className="h-60 w-auto object-contain mx-auto"
          />
          {/* <h1 style={{ color: colors.primary }} className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Welcome to HennabyAnjali
          </h1> */}
          <p style={{ color: colors.text.medium }} className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
            Where tradition meets artistry. Discover exquisite henna designs and stunning nail art crafted with passion in Melbourne.
          </p>
        </div>

        {/* Service Selection Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mt-16">
          {/* Henna Card */}
          <Link to="/henna">
            <div 
              style={{ backgroundColor: colors.white, borderColor: colors.highlight }}
              className="group relative overflow-hidden rounded-2xl border-2 transition-all duration-300 hover:shadow-2xl hover:scale-[1.02]"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src="https://images.pexels.com/photos/35490980/pexels-photo-35490980.jpeg" 
                  alt="Henna Art"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <Sparkles style={{ color: colors.highlight }} size={28} />
                  <h2 style={{ color: colors.primary }} className="text-3xl font-bold">Henna Art</h2>
                </div>
                <p style={{ color: colors.text.medium }} className="text-lg mb-6 leading-relaxed">
                  Intricate mehndi designs for bridal events. Traditional artistry with a modern touch.
                </p>
                <div style={{ color: colors.highlight }} className="flex items-center space-x-2 font-semibold text-lg group-hover:translate-x-2 transition-transform duration-300">
                  <span>Explore Henna Services</span>
                  <ArrowRight size={20} />
                </div>
              </div>
            </div>
          </Link>

          {/* Nail Art Card */}
          <Link to="/nail-art">
            <div 
              style={{ backgroundColor: colors.white, borderColor: colors.highlight }}
              className="group relative overflow-hidden rounded-2xl border-2 transition-all duration-300 hover:shadow-2xl hover:scale-[1.02]"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src="https://images.pexels.com/photos/704815/pexels-photo-704815.jpeg" 
                  alt="Nail Art"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <Palette style={{ color: colors.highlight }} size={28} />
                  <h2 style={{ color: colors.primary }} className="text-3xl font-bold">Nail Art</h2>
                </div>
                <p style={{ color: colors.text.medium }} className="text-lg mb-6 leading-relaxed">
                  Professional acrylic gel nails and custom press-on designs. Express your style with stunning nail art.
                </p>
                <div style={{ color: colors.highlight }} className="flex items-center space-x-2 font-semibold text-lg group-hover:translate-x-2 transition-transform duration-300">
                  <span>Explore Nail Art</span>
                  <ArrowRight size={20} />
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-20 mb-10">
          <Link to="/contact">
            <Button
              style={{ backgroundColor: colors.highlight, color: colors.white }}
              className="px-8 py-6 text-lg font-semibold rounded-full transition-all duration-300 hover:opacity-90 hover:scale-105"
            >
              Book Your Appointment
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;